<template>
    <div class="s2w-auto-update-selector-container">
        <div class="s2w-auto-update-label">
            {{ $t('BaseSaveToWorkspace.AutoUpdate.otherSettingLabel') }}
        </div>
        <div
            class="s2w-auto-update"
            :class="{
                disabled
            }"
        >
            <div
                class="s2w-auto-update-switch"
                :class="{ enable }"
                @click="toggleAutoUpdate()"
            />
            <div class="s2w-auto-update-desc">
                <span>{{ AutoUpdateLabel }}</span>
            </div>
            <div
                class="s2w-auto-update-info"
                :aria-label="AutoUpdateLabelTip"
                data-balloon-pos="up"
                data-balloon-white
            >
                <PtIcon
                    icon="SolidInfo"
                    style="font-size: 24px;"
                />
            </div>
            <div class="s2w-auto-update-query-container">
                <div
                    class="s2w-auto-update-query-link"
                    @click="showQueryPopper = !showQueryPopper"
                >
                    {{ $t('BaseSaveToWorkspace.AutoUpdate.viewQuery') }}
                </div>
                <div
                    v-if="showQueryPopper"
                    class="s2w-auto-update-query-popper"
                    @mousedown.stop
                >
                    <div class="s2w-auto-update-query-content">
                        {{ autoUpdate.q }}
                    </div>
                    <div
                        v-if="autoUpdate.efq"
                        class="s2w-auto-update-query-content s2w-efq"
                    >
                        {{ $t('BaseSaveToWorkspace.AutoUpdate.refine') }}: {{ autoUpdate.efq }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PtIcon from '@patsnap-biz/icon';
import '@patsnap-ui/icon/assets/solid/info.svg';

export default {
    name: 'AutoUpdateSelector',
    components: {
        PtIcon,
    },
    inject: ['service'],
    data() {
        return {
            showQueryPopper: false,
        };
    },
    computed: {
        autoUpdate() {
            return this.service.autoUpdate;
        },
        enable() {
            return this.service.autoUpdate.enable;
        },
        disabled() {
            const {
                rangeSelector, folderSelector, disabledAllType, enableRange,
                enableFamily,
            } = this.service;
            const { selectedFolder } = folderSelector;
            const { selectedType, family } = rangeSelector;

            if (selectedFolder && selectedFolder.folder_auto_update) {
                return true;
            }

            if (selectedType === 'RANGE') {
                return true;
            }

            if (enableFamily && family.enable) {
                return true;
            }

            if (enableRange && disabledAllType) return true;

            return false;
        },
        familyMode() {
            return this.service.familyMode;
        },
        AutoUpdateLabel() {
            return this.familyMode
                ? this.$t('BaseSaveToWorkspace.AutoUpdate.familylabel')
                : this.$t('BaseSaveToWorkspace.AutoUpdate.label');
        },
        AutoUpdateLabelTip() {
            return this.familyMode
                ? this.$t('BaseSaveToWorkspace.AutoUpdate.familyTip')
                : this.$t('BaseSaveToWorkspace.AutoUpdate.tip');
        },
    },
    created() {
        this.closeQueryPopper = () => {
            this.showQueryPopper = false;
        };
        document.addEventListener('mousedown', this.closeQueryPopper);
    },
    beforeDestroy() {
        document.removeEventListener('mousedown', this.closeQueryPopper);
    },
    methods: {
        toggleAutoUpdate() {
            if (this.disabled) return false;
            this.service.toggleAutoUpdate();
            return true;
        },
    },
};
</script>
